import { useSearchBox } from 'react-instantsearch-core';
import { useCallback, useState } from 'react';
const useAutoSuggest = () => {
  const {
    query,
    clear
  } = useSearchBox();
  const [value, setValue] = useState(query);
  const clearSearch = useCallback(() => {
    clear();
  }, [setValue]);
  return {
    clearSearch,
    value,
    setValue
  };
};
export default useAutoSuggest;